import whatsappIcon from "../../assets/utils/images/whatsapp.png";
import websiteChat from "../../assets/utils/images/website_chat.png";
import linkGenerator from "../../assets/utils/images/link_generator.png";
import emailParser from "../../assets/utils/images/email-scanner.png";
import apiKey from "../../assets/utils/images/api-key.png";
import facebook from "../../assets/utils/images/facebook.png";
import indiamart from "../../assets/utils/images/indiamart.png";
import googleLeadForm from "../../assets/utils/images/googleLeadForm.png";
import apiIcon from "../../assets/utils/images/apiicon.png";
import webhooks from "../../assets/utils/images/webhooks.png";
import pabbly from "../../assets/utils/images/pabbly.png";
import trade_india from "../../assets/utils/images/Trade_India.png";
import justdial from "../../assets/utils/images/JustDial.png";
import sulekha from "../../assets/utils/images/Sulekha.png";
import ninetynineacres from "../../assets/utils/images/99acres.png";
import magicbricks from "../../assets/utils/images/Magic_Bricks.png";
import housing_dot_com from "../../assets/utils/images/Housing_Dot_com.png";
import shiksha from "../../assets/utils/images/Shiksha.png";
import collegedunia from "../../assets/utils/images/College_Dunia.png";
import elementor_forms from "../../assets/utils/images/Elementor_Forms.png";
import wpforms from "../../assets/utils/images/WPForms.png";
import optinmonster from "../../assets/utils/images/OptinMonster.png";
import tawkdotto from "../../assets/utils/images/Tawkdotto.png";
import linkedin from "../../assets/utils/images/Linked_In.png";
import google_sheets from "../../assets/utils/images/Google_Sheet.png";
import google_forms from "../../assets/utils/images/Google_Form.png";
import shopify from "../../assets/utils/images/Shopify.png";
import woocommerce from "../../assets/utils/images/Woo_Commerce.png";
import razorpay from "../../assets/utils/images/Razorpay.png";
import phonepe from "../../assets/utils/images/PhonePe.png";
import zoom from "../../assets/utils/images/Zoom.png";
import everwebinar from "../../assets/utils/images/Ever_Webinar.png";

export const statusOptions = [
    {
        label: 'All', value: 'All'
    },
    {
        label: 'Sent', value: 'read,replied,sent,delivered' //read,replied,sent,delivered,undeliverable,failed
    },
    {
        label: 'Delivered', value: 'delivered' // ,read,replied
    },
    {
        label: 'Read', value: 'read' // sent,delivered
    },
    {
        label: 'Un Deliverable', value: 'undeliverable'
    },
    {
        label: 'Replied', value: 'replied'
    },
    /*{
        label: 'Complained', value: 'complained'
},*/
    {
        label: 'Failed', value: 'failed'
    }
];
export const typeOptions = [
    {
        label: 'All', value: 'All'
    },
    {
        label: 'Campaigns', value: 'campaigns'
    },
    {
        label: 'Automations', value: 'automations'
    },
    {
        label: 'Workflows', value: 'workflows'
    }
];
export const DayOptions = [
    {
        label: 'Monday', value: 'Mon'
    },
    {
        label: 'Tuesday', value: 'Tue'
    },
    {
        label: 'Wednesday', value: 'Wed'
    },
    {
        label: 'Thursday', value: 'Thu'
    },
    {
        label: 'Friday', value: 'Fri'
    },
    {
        label: 'Saturday', value: 'Sat'
    },
    {
        label: 'Sunday', value: 'Sun'
    }
];
export const TimeOptions = [
    {
        label: '00:00AM', value: '00:00AM'
    },
    {
        label: '01:00AM', value: '01:00AM'
    },
    {
        label: '02:00AM', value: '02:00AM'
    },
    {
        label: '03:00AM', value: '03:00AM'
    },
    {
        label: '04:00AM', value: '04:00AM'
    },
    {
        label: '05:00AM', value: '05:00AM'
    },
    {
        label: '06:00AM', value: '06:00AM'
    },
    {
        label: '07:00AM', value: '07:00AM'
    },
    {
        label: '08:00AM', value: '08:00AM'
    },
    {
        label: '09:00AM', value: '09:00AM'
    },
    {
        label: '10:00AM', value: '10:00AM'
    },
    {
        label: '11:00AM', value: '11:00AM'
    },
    {
        label: '12:00PM', value: '12:00PM'
    },
    {
        label: '01:00PM', value: '01:00PM'
    },
    {
        label: '02:00PM', value: '02:00PM'
    },
    {
        label: '03:00PM', value: '03:00PM'
    },
    {
        label: '04:00PM', value: '04:00PM'
    },
    {
        label: '05:00PM', value: '05:00PM'
    },
    {
        label: '06:00PM', value: '06:00PM'
    },
    {
        label: '07:00PM', value: '07:00PM'
    },
    {
        label: '08:00PM', value: '08:00PM'
    },
    {
        label: '09:00PM', value: '09:00PM'
    },
    {
        label: '10:00PM', value: '10:00PM'
    },
    {
        label: '11:00PM', value: '11:00PM'
    }
];

export const IntegrationListItems = [
    /*{
        name : "API",
        crname : "api",
        desc : "Build powerful integrations using our comprehensive set of APIs",
        image : "",
        btnText : "Explore Now"
    },*/
    {
        name : "FB Lead Ads Forms",
        crname : "facebook_mapping",
        desc : "Capture leads instantly from Lead Ads Forms.",
        image : facebook,
        appType : 0,
        btnText : "Create Your Mapping",
        isAdminOnly : false
    },
    {
        name : "Google Lead Forms",
        crname : "googleads",
        desc : "Capture leads instantly from Google Ads form extension.",  
        image : googleLeadForm,
        appType : 0,
        btnText : "Create Your Mapping",
        isAdminOnly : true
    },
    {
        name : "IndiaMart Leads",
        crname : "indiamart",
        desc : "Capture leads instantly from IndiaMart business account.",  
        image : indiamart,
        appType : 0,
        btnText : "Integrate Your IndiaMart",
        isAdminOnly : false
    },
    {
        name : "Email Parser",
        crname : "email_parser",
        desc : "Capture leads, from incoming emails automatically.",  
        image : emailParser,
        appType : 0,
        btnText : "Configure Email To Leads",
        isAdminOnly : false
    },
    {
        name : "Website Chat",
        crname : "website_chat",
        desc : "Get a free WhatsApp Live Chat Button for your website.",  
        image : websiteChat,
        appType : 0,
        btnText : "Get Your Widget",
        isAdminOnly : false
    },
    {
        name : "Link Generator",
        crname : "link_generator",
        desc : "Generate click-to-chat links for Free in just two steps!",  
        image : linkGenerator,
        appType : 0,
        btnText : "Generate Link",
        isAdminOnly : false
    },
    {
        name : "API Key",
        crname : "api_key",
        desc : "Integrate with other 3rd party apps using API.",  
        image : apiKey,
        appType : 0,
        btnText : "Get Your API Key",
        isAdminOnly : false
    },
    {
        name : "Webhooks",
        crname : "webhooks",
        desc : "Capture real-time data sent from other 3rd party apps.",  
        image : webhooks,
        appType : 0,
        btnText : "Create Webhooks",
        isAdminOnly : true
    },
    {
        name : "Pabbly",
        crname : "pabbly",
        desc : "Connect Cratio CRM with Over 1,500 Apps via Pabbly Connect",  
        image : pabbly,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false
    },
    {
        name : "Trade India",
        crname : "trade_india",
        desc : "Capture leads instantly from the Trade India portal.",  
        image : trade_india,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "JustDial",
        crname : "justdial",
        desc : "Capture leads instantly from JustDial portal.",  
        image : justdial,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Sulekha",
        crname : "sulekha",
        desc : "Capture leads instantly from Sulekha portal.",  
        image : sulekha,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "99acres",
        crname : "99acres",
        desc : "Capture leads instantly from 99acres portal.",  
        image : ninetynineacres,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "MagicBricks",
        crname : "magicbricks",
        desc : "Capture leads instantly from MagicBricks portal.",  
        image : magicbricks,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Housing.com",
        crname : "housing_dot_com",
        desc : "Capture leads instantly from Housing.com portal.",  
        image : housing_dot_com,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Shiksha",
        crname : "shiksha",
        desc : "Capture leads instantly from Shiksha portal.",  
        image : shiksha,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "CollegeDunia",
        crname : "collegedunia",
        desc : "Capture leads instantly from CollegeDunia portal.",  
        image : collegedunia,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Elementor Forms",
        crname : "elementor_forms",
        desc : "Capture leads instantly from Elementor Forms.",  
        image : elementor_forms,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "WPForms",
        crname : "wpforms",
        desc : "Capture leads instantly from WPForms.",  
        image : wpforms,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "OptinMonster",
        crname : "optinmonster",
        desc : "Capture leads instantly from OptinMonster Forms.",  
        image : optinmonster,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Tawk.to",
        crname : "tawkdotto",
        desc : "Connect Tawk.to with Cratio CRM via Pabbly Connect.",  
        image : tawkdotto,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Linkedin Lead Form",
        crname : "linkedin_lead_form",
        desc : "Capture leads instantly from Linkedin Lead Form via Pabbly Connect.",  
        image : linkedin,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Google Sheets",
        crname : "google_sheets",
        desc : "Connect Google Sheets with Cratio CRM via Pabbly Connect.",  
        image : google_sheets,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Google Forms",
        crname : "google_forms",
        desc : "Connect Google Forms with Cratio CRM via Pabbly Connect.",  
        image : google_forms,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Shopify",
        crname : "shopify",
        desc : "Connect Shopify with Cratio CRM via Pabbly Connect.",  
        image : shopify,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "WooCommerce",
        crname : "woocommerce",
        desc : "Connect WooCommerce with Cratio CRM via Pabbly Connect.",  
        image : woocommerce,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Razorpay",
        crname : "razorpay",
        desc : "Connect Razorpay with Cratio CRM via Pabbly Connect.",  
        image : razorpay,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Phonepe",
        crname : "phonepe",
        desc : "Connect Phonepe with Cratio CRM via Pabbly Connect.",  
        image : phonepe,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "Zoom",
        crname : "zoom",
        desc : "Connect Zoom with Cratio CRM via Pabbly Connect.",  
        image : zoom,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    },
    {
        name : "EverWebinar",
        crname : "everwebinar",
        desc : "Connect EverWebinar with Cratio CRM via Pabbly Connect.",  
        image : everwebinar,
        appType : 0,
        btnText : "Contact us",
        isAdminOnly : false,
        url : "https://support.cratio.com/support/tickets/new"
    }

];

export const exportRecordsCounts = [
    {
        label : "10000 Records",
        value : 10000
    },
    {
        label : "20000 Records",
        value : 20000
    },
    {
        label : "30000 Records",
        value : 30000
    },
    {
        label : "40000 Records",
        value : 40000
    },
    {
        label : "50000 Records",
        value : 50000
    },
] 

export const IntegrationListSearchItems = [
    /*{
        name : "API",
        crname : "api",
        desc : "Build powerful integrations using our comprehensive set of APIs",
        image : "",
        btnText : "Explore Now"
    },*/
    {
        label : "All",
        value : "all_items",
        
    },
    {
        label : "Paid Ads",
        value : ["googleads", "facebook_mapping", "linkedin_lead_form"],
        
    },
    {
        label : "Portals",
        value : ["indiamart","justdial", "sulekha", "trade_india"],
        
    },
    {
        label : "Real Estate",
        value : ["magicbricks", "99acres", "housing_dot_com"],
        
    },
    {
        label : "Education",
        value : ["shiksha", "collegedunia"],
        
    },
    {
        label : "Optin Forms",
        value : ["optinmonster", "tawkdotto"],
        
    },
    {
        label : "Google",
        value : ["google_forms", "google_sheets"],
        
    },
    {
        label : "Ecommerce",
        value : ["shopify", "woocommerce"],
        
    },
    {
        label : "Payments",
        value : ["razorpay", "phonepe"],
        
    },
    {
        label : "Webinar",
        value : ["zoom","everwebinar"],
        
    },
    {
        label : "API",
        value : ["api_key", "webhooks", "email_parser"],
        
    },
    {
        label : "WhatsApp",
        value : ["website_chat", "link_generator"],
        
    },
    {
        label : "Pabbly",
        value : ["pabbly"],

    }

];
